export const INTERNAL_LINK_TYPE_ID = 'internal-link';
export const MENU_ITEM_TYPE_ID = 'menu-item';
export const PAGE_TYPE_ID = 'page';
export const PAGE_REFERENCE_TYPE_ID = 'page-reference';
export const SITE_SECTION_TYPE_ID = 'site-section';
export const IMAGE_ASSET_TYPE_ID = 'image';
//# sourceMappingURL=contentTypes.js.map